import { mdiCheckboxBlankCircleOutline } from '@mdi/js'

const themeConfig = {
  app: {
    name: 'LightApply',
    logo: require('@/assets/images/svg/logo.svg'),
    logoDark: require('@/assets/images/svg/logo_dark.svg'),
    isDark: false,
    isRtl: false,
    contentLayoutNav: 'vertical', // vertical, horizontal
    routeTransition: 'scroll-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: 'default', // default, bordered, semi-dark
    contentWidth: 'full',
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: 'fixed', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'static', // fixed, static, hidden
  },
  themes: {
    light: {
      primary: '#F9D97D',
      accent: '#6A5AFA',
      secondary: '#8A8D93',
      success: '#3AC26A',
      info: '#16B1FF',
      warning: '#FA833A',
      error: '#EA4949',
      primary_c1: '#FFF7D4',
      primary_c2: '#FFF1B6',
      primary_c3: '#FFEA94',
      primary_c4: '#EDAC58',
      primary_c5: '#DB773D',
      primary_c6: '#A14327',
      primary_ct: '#A14327',
      text_c0: '#FFFFFF',
      text_c1: '#4E4E4E',
      text_c2: '#2B2B2B',
      text_c3: '#000000',
      background_1: '#FFFFFF',
      background_2: '#F9F9F9',
    },
    dark: {
      primary: '#EDAC58',
      accent: '#6A5AFA',
      secondary: '#8A8D93',
      success: '#3AC26A',
      info: '#16B1FF',
      warning: '#FA833A',
      error: '#EA4949',
      primary_c1: '#A14327',
      primary_c2: '#DB773D',
      primary_c3: '#EDAC58',
      primary_c4: '#FFEA94',
      primary_c5: '#FFF1B6',
      primary_c6: '#FFF7D4',
      primary_ct: '#A14327',
      text_c0: '#000000',
      text_c1: '#CBCBCB',
      text_c2: '#EBEBEB',
      text_c3: '#FFFFFF',
      background_1: '#1F1F1F',
      background_2: '#0D0D0D',
    },
  },
}

export default themeConfig
